import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";

export function getMyAccount(state: ApplicationState) {
    return getPageStateByType(state, "MyAccountPage").value || nullPage;
}
